import Vue from "vue";

Vue.filter("rate", (value) => parseInt(value * 100) / 100);



// WEBPACK FOOTER //
// ./src/filters/rate.filter.js